(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'product-recommendations'
  var productRecommendationsSection = document.querySelector(".product-recommendations");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      // If Shopify returns a Liquid error page/snippet, don't inject it.
      // This prevents storefront-visible "Liquid error ... internal" blocks.
      if (typeof request.responseText === "string" && request.responseText.indexOf("Liquid error") !== -1) {
        productRecommendationsSection.parentNode && productRecommendationsSection.parentNode.removeChild(productRecommendationsSection);
        return;
      }
      var container = document.createElement("div");
      container.innerHTML = request.response;
      var newSection = container.querySelector(".product-recommendations");
      if (!newSection) {
        productRecommendationsSection.parentNode && productRecommendationsSection.parentNode.removeChild(productRecommendationsSection);
        return;
      }
      productRecommendationsSection.innerHTML = newSection.innerHTML;
      try { theme.ProductBlockManager.loadImages(productRecommendationsSection); } catch (e) {}
      try { theme.initAnimateOnScroll(); } catch (e) {}
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].product-recommendations')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
